import React, { useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../services/api';
import TCLogo from './TCLogo';

const ResetPassword = () => {
  const { org_slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [form, setForm] = useState({ new_password: '', confirm_password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.new_password !== form.confirm_password) {
      return setError('Passwords do not match');
    }
    if (form.new_password.length < 8) {
      return setError('Password must be at least 8 characters');
    }
    setLoading(true);
    try {
      await resetPassword({ token, new_password: form.new_password });
      setSuccess(true);
      setTimeout(() => navigate(`/${org_slug}/login`), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg, #1B3A5C 0%, #2E75B6 100%)',padding:'20px'}}>
      <div style={{background:'white',borderRadius:'12px',padding:'40px',width:'100%',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <TCLogo size={56} />
          <h1 style={{fontSize:'24px',fontWeight:'700',color:'#1B3A5C',marginTop:'12px',marginBottom:'4px'}}>Set New Password</h1>
          <p style={{color:'#595959',fontSize:'13px'}}>CONSAM DMS</p>
        </div>
        {success ? (
          <div style={{textAlign:'center',padding:'8px'}}>
            <div style={{fontSize:'48px',color:'#1E7B34',marginBottom:'16px'}}>✓</div>
            <h3 style={{fontSize:'20px',fontWeight:'700',color:'#1B3A5C',marginBottom:'8px'}}>Password Reset!</h3>
            <p style={{color:'#595959',fontSize:'14px'}}>Redirecting to login...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={form.new_password}
                onChange={e => setForm({...form, new_password: e.target.value})}
                placeholder="Minimum 8 characters" required autoFocus />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={form.confirm_password}
                onChange={e => setForm({...form, confirm_password: e.target.value})}
                placeholder="Repeat new password" required />
            </div>
            {error && <p className="error-msg">{error}</p>}
            <button type="submit" className="btn btn-primary"
              style={{width:'100%',padding:'12px',fontSize:'15px',marginTop:'8px'}}
              disabled={loading}>
              {loading ? 'Saving...' : 'Set New Password'}
            </button>
            <div style={{textAlign:'center',marginTop:'16px'}}>
              <a href={`/${org_slug}/login`} style={{color:'#2E75B6',textDecoration:'none',fontSize:'13px'}}>
                ← Back to Login
              </a>
            </div>
          </form>
        )}
      </div>
      <p style={{color:'rgba(255,255,255,0.5)',fontSize:'11px',marginTop:'20px'}}>
        © 2026 CONSAM. All rights reserved.
      </p>
    </div>
  );
};

export default ResetPassword;
